import styled from "styled-components/native";
import { colors } from "shared-components/src/utils/constants";

export default styled.View`
  background-color: ${colors.white};
  border-radius: 5.2px;
  width: 100%;
  padding: 16px;
`;
